import { Controller } from "stimulus"
import { useHotkeys } from "stimulus-use"

export default class extends Controller {

  static targets = ["currentTime", "timesList"];

  connect() {
    useHotkeys(this, {
      "up": [this.goToPastTime],
      "down": [this.goToFutureTime],
    });





    this.scrollToSavedPos();

    let params = new URLSearchParams(document.location.search);
    let auditID = params.get("audit");
    let time = params.get("time");
    // if (!!time) {
    //   document.documentElement.style.overflow = "hidden";
    // }

    // if (!!auditID) {
    //   this.timesListTarget.querySelector("#audit_" + auditID).scrollIntoView({block: "nearest", inline: "start"})
    // }

  }


  goToFutureTime() {
    var nextTime = this.currentTimeTarget.nextElementSibling;
    console.log(nextTime);
    if (nextTime?.classList.contains("time-link-wrapper")) {
      nextTime.querySelector(".time-link").click();
      nextTime.scrollIntoView()
      setTimeout(() => {
        this.saveScrollPos();
      }, 0);
    }
  }

  goToPastTime() {
    var prevTime = this.currentTimeTarget.previousElementSibling;
    console.log(prevTime);
    if (prevTime?.classList.contains("time-link-wrapper")) {
      prevTime.querySelector(".time-link").click();
      prevTime.scrollIntoView()
      setTimeout(() => {
        this.saveScrollPos();
      }, 0);
    }
  }


  scrollToSavedPos() {
    var tmscrollpos = localStorage.getItem('tmscrollpos');
    if (tmscrollpos) this.timesListTarget.scrollTop = tmscrollpos;
  }

  saveScrollPos() {
    localStorage.setItem('tmscrollpos', this.timesListTarget.scrollTop);
  }

}